import { render, staticRenderFns } from "./DoctorCardHeader.vue?vue&type=template&id=0b97104f&scoped=true&"
import script from "./DoctorCardHeader.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardHeader.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorCardHeader.vue?vue&type=style&index=0&id=0b97104f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97104f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b97104f')) {
      api.createRecord('0b97104f', component.options)
    } else {
      api.reload('0b97104f', component.options)
    }
    module.hot.accept("./DoctorCardHeader.vue?vue&type=template&id=0b97104f&scoped=true&", function () {
      api.rerender('0b97104f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardHeader.vue"
export default component.exports